// WhatsApp redirect URLs are managed from the /admin panel. There can be more
// than one; the frontend alternates between them in round-robin order.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULT_URLS = [
  "https://api.whatsapp.com/send?phone=+16187473815&text=AC0A3C",
];

let _urls = [...DEFAULT_URLS];
let _idx = 0;
let _loadPromise = null;

export const getWhatsAppUrls = () => [..._urls];

// Returns the next URL in rotation. Advances the pointer. Falls back to the
// first URL if none configured.
export const nextWhatsAppUrl = () => {
  if (!_urls.length) return DEFAULT_URLS[0];
  const url = _urls[_idx % _urls.length];
  _idx = (_idx + 1) % _urls.length;
  return url;
};

// Returns the next URL *without* advancing (useful for previews/UI).
export const peekWhatsAppUrl = () => {
  if (!_urls.length) return DEFAULT_URLS[0];
  return _urls[_idx % _urls.length];
};

export const loadWhatsAppConfig = () => {
  if (_loadPromise) return _loadPromise;
  _loadPromise = axios
    .get(`${API}/config/whatsapp`)
    .then((res) => {
      const urls = Array.isArray(res.data?.urls) ? res.data.urls : [];
      if (urls.length) {
        _urls = urls;
        _idx = 0;
      }
      return { urls: _urls };
    })
    .catch(() => ({ urls: _urls }));
  return _loadPromise;
};

export const setCachedWhatsAppUrls = (urls) => {
  if (Array.isArray(urls) && urls.length) {
    _urls = urls;
    _idx = 0;
  }
};

// Backwards-compatible named export: current/first URL.
export const WHATSAPP_URL = _urls[0];

export const openWA = () => {
  window.location.href = nextWhatsAppUrl();
};
